const updateSliderTheme = (swiper) => {
	const pag = swiper.el.closest('.slider')?.querySelector('.slider__pagination');
	if (!pag) return;

	const bright = parseFloat(swiper.slides[swiper.activeIndex].dataset.brightness);
	const isLight = bright > 128;

	pag.classList.toggle('slider__pagination--light', isLight);
	pag.classList.toggle('slider__pagination--dark', !isLight);

	const header = document.querySelector('.header');
	if (header) {
		header.classList.toggle('header--light', isLight);
		header.classList.toggle('header--dark', !isLight);
	}
};

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.slider').forEach(el => {
		const swiper = el.querySelector('.swiper')?.swiper;
		if (swiper) {
			swiper.on('slideChange', () => updateSliderTheme(swiper));
			updateSliderTheme(swiper);
		}
	});
});